import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Text,
  Input,
  Stack,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { resetPassword } from "../../../redux/actions/user/UserActions";
import { RootStore } from "../../../redux/Store";

function ResetPassword(props: any): JSX.Element {
  const [regClickState, setregClickState] = useState(false);
  const [resetPasswordData, setResetPasswordData] = useState<IuserReg>({});
  const userState = useSelector((state: RootStore) => state.user);
  const dispatch = useDispatch();

  const validation = (): boolean => {
    let isValid = true;

    if (!resetPasswordData.password || !resetPasswordData.verifyPassword) {
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = () => {
    setregClickState(true);
    if (validation()) {
      if (props.match.path === "/user-reset-password/:resetKey") {
        dispatch(
          resetPassword(
            props,
            String(resetPasswordData.verifyPassword),
            String(resetPasswordData.verifyPassword)
          )
        );
      }
    }
  };
  return (
    <Flex
      minH={"80vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("white", "gray.700")}
    >
      <Stack
        spacing={4}
        w={"full"}
        maxW={"lg"}
        bg={useColorModeValue("gray.50", "gray.800")}
        rounded={"xl"}
        boxShadow={"lg"}
        p={10}
        my={12}
      >
        <Heading lineHeight={1.1} fontSize={{ base: "2xl", md: "3xl" }}>
          Provide New Password
        </Heading>
        <FormControl id="email" isRequired>
          <FormLabel>New Password</FormLabel>
          <Input
            isInvalid={
              regClickState ? !resetPasswordData.password && true : false
            }
            placeholder="Enter new password"
            _placeholder={{ color: "gray.500" }}
            bg={useColorModeValue("white", "gray.700")}
            onChange={(event) =>
              setResetPasswordData({
                ...resetPasswordData,
                password: event.target.value,
              })
            }
            type="password"
            id="NewPassword"
            name="NewPassword"
            required
          />
          {regClickState && !resetPasswordData.password && (
            <Text fontSize="xs" color="red" marginTop="3px">
              {"This field must not be empty"}
            </Text>
          )}
        </FormControl>
        <FormControl id="password" isRequired>
          <FormLabel>Verify New Password</FormLabel>
          <Input
            isInvalid={
              regClickState
                ? !resetPasswordData.verifyPassword
                  ? true
                  : resetPasswordData.password !=
                      resetPasswordData.verifyPassword && true
                : false
            }
            type="password"
            onChange={(event) =>
              setResetPasswordData({
                ...resetPasswordData,
                verifyPassword: event.target.value,
              })
            }
            placeholder="Verify new password"
            _placeholder={{ color: "gray.500" }}
            bg={useColorModeValue("white", "gray.700")}
            required
            id="VerifyNewPassword"
            name="VerifyNewPassword"
          />
          {regClickState && (
            <Text fontSize="xs" color="red" marginTop="3px">
              {!resetPasswordData.verifyPassword
                ? "This field must not be empty"
                : resetPasswordData.password !=
                    resetPasswordData.verifyPassword &&
                  "Password does not match"}
            </Text>
          )}
        </FormControl>
        {userState.forgotResetPassword?.message && (
          <Text style={{ marginTop: "20px" }} fontSize="sm" color="red">
            {userState.forgotResetPassword.message}
          </Text>
        )}
        <Stack spacing={6}>
          <Button
            bg={"blue.400"}
            color={"white"}
            _hover={{
              bg: "blue.500",
            }}
            onClick={handleSubmit}
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
            id="ResetPassword"
            name="ResetPassword"
          >
            Reset Password
          </Button>
        </Stack>
      </Stack>
    </Flex>
  );
}
export default ResetPassword;
